import api from './client';

export const adminGetSettings = async () => {
  const res = await api.get('/admin/settings');
  return res.data;
};

export const adminUpdateSettings = async (payload) => {
  const res = await api.patch('/admin/settings', payload);
  return res.data;
};

export const adminPendingPosts = async () => {
  const res = await api.get('/admin/posts/pending');
  return res.data;
};

export const adminSetPostApproval = async (postId, status) => {
  const res = await api.patch(`/admin/posts/${postId}/approval`, { status });
  return res.data;
};

export const adminSetUserStatus = async (userId, status) => {
  const res = await api.patch(`/admin/users/${userId}/status`, { status });
  return res.data;
};

export const adminFinance = async () => {
  const res = await api.get('/admin/finance');
  return res.data;
};

export const adminActiveLives = async () => {
  const res = await api.get('/admin/lives/active');
  return res.data;
};

export const adminSmtpTest = async (to_email, subject, body) => {
  const res = await api.post('/admin/settings/smtp-test', { to_email, subject, body });
  return res.data;
};

export const adminSmsTest = async (phone) => {
  const res = await api.post('/admin/settings/sms-test', { phone });
  return res.data;
};

export const adminLiveBroadcastPreview = async () => {
  const res = await api.post('/admin/live-broadcast/preview');
  return res.data;
};

export const adminListEmailLogs = async (limit = 100) => {
  const res = await api.get('/admin/logs/emails', { params: { limit } });
  return res.data;
};

export const adminListMetaEvents = async (limit = 100) => {
  const res = await api.get('/admin/logs/meta-events', { params: { limit } });
  return res.data;
};
